import moment from 'moment';
import actionConst from "../../constants/edit-document.constants";
import { authHeader } from "../../../../helpers/auth-header";
import { client } from "../../../../actions";
import { documentsActions } from "./documents.actions";
import {
  docTypes,
  documentsConstants,
} from '../../constants/documents.constants';
import { fromDateStr } from "../../../../helpers/utcDate";

const actions = {
	openModal,
	closeModal,
	updateAppointedWorkers,
	updateAddress,
	updateStatus,
	addAddress,
	updateDoneDate,
	deleteExecuter,
	updateResponsibleWorker,
  updateVisibility,
  updateNotification,
  updateDocNumber,
  updateDocRegDate,
  updateDocTopic,
	deleteClient,
	addClient,
	addOrgToDoc,
	deleteAddress,
	deleteOrgFromDoc,
};

function updateAddress(addressConnectId, newAddressId) {
	const url = "/Docs/update_address";
	const data = {
		id: Number(addressConnectId),
		addressId: Number(newAddressId),
	};
	return (dispatch) => {
		client
			.put(
				url,
				{},
				{
					headers: authHeader(),
					params: data,
				}
			)
			.then(() => {
				dispatch(documentsActions.fetchDocuments());
			})
			.catch(function (error) {
				console.log("=== document update error ========= ");
				console.log(error);
				dispatch({
					type: documentsConstants.POST_ERROR,
					payload: error,
				});
			});
	};
}

function deleteAddress(addressId) {
	const url = "/Docs/delete_address";

	return (dispatch) => {
		client
			.delete(
				url,
				{
					headers: authHeader(),
					params: { id: addressId },
				}
			)
			.then(() => {
				dispatch(documentsActions.fetchDocuments());
			})
			.catch(function (error) {
				console.log("=== document update error ========= ");
				console.log(error);
				dispatch({
					type: documentsConstants.POST_ERROR,
					payload: error,
				});
			});
	};
}

function addAddress(docId, addressId) {
	const url = "/Docs/addAddress";
	const data = {
		DocId: docId && Number(docId),
		AddressId: addressId && Number(addressId),
	};
	return (dispatch) => {
		client
			.post(url, data, {
				headers: authHeader(),
			})
			.then(() => {
				dispatch(documentsActions.fetchDocuments());
			})
			.catch(function (error) {
				console.log("=== document update error ========= ");
				console.log(error);
				dispatch({
					type: documentsConstants.POST_ERROR,
					payload: error,
				});
			});
	};
}

function addClient(id, clientName) {
	const url = `/docs/counterparty_owner`;
	return (dispatch) => {
		client
			.post(
				url,
				{ id, name: clientName },
				{
					headers: authHeader(),
				}
			)
			.then(() => {
				dispatch(documentsActions.fetchDocuments());
			})
			.catch(function (error) {
				console.log("=== document update error ========= ");
				console.log(error);
				dispatch({
					type: documentsConstants.POST_ERROR,
					payload: error,
				});
			});
	};
}

function deleteClient(id) {
	const url = `/docs/counterparty_owner`;
	return (dispatch) => {
		client
			.delete(
				url,
				{
					headers: authHeader(),
					params: { id: Number(id) },
				}
			)
			.then(() => {
				dispatch(documentsActions.fetchDocuments());
			})
			.catch(function (error) {
				console.log("=== document update error ========= ");
				console.log(error);
				dispatch({
					type: documentsConstants.POST_ERROR,
					payload: error,
				});
			});
	};
}

function addOrgToDoc(docId, orgId) {
	const url = `/Docs/addOrgToDoc/${docId}`;
	const dataParams = {
		id: Number(orgId),
	};
	const dataBody = {
		id: Number(docId),
		orgId: Number(orgId),
	};
	return (dispatch) => {
		client
			.post(url, dataBody, {
				headers: authHeader(),
				params: { ...dataParams },
			})
			.then(() => {
				dispatch(documentsActions.fetchDocuments());
			})
			.catch(function (error) {
				console.log("=== document update error ========= ");
				console.log(error);
				dispatch({
					type: documentsConstants.POST_ERROR,
					payload: error,
				});
			});
	};
}

function deleteOrgFromDoc(docId, orgId) {
	const url = `/Docs/deleteOrgFromDoc`;
	return (dispatch) => {
		client
			.delete(url, {
				headers: authHeader(),
				params: { docId, orgId },
			})
			.then(() => {
				dispatch(documentsActions.fetchDocuments());
			})
			.catch(function (error) {
				console.log("=== document update error ========= ");
				console.log(error);
				dispatch({
					type: documentsConstants.POST_ERROR,
					payload: error,
				});
			});
	};
}

function updateDoneDate(v) {
	const url = "/docs/update_done_date";
	const data = {
		doneDate: fromDateStr(v.changedDoneDate),
		comment: v.changedDoneDateComment || "",
		docId: Number(v.id),
	};
	return (dispatch) => {
		client
			.put(url, {}, {
				headers: authHeader(),
				params: data,
			})
			.then(() => {
				dispatch(documentsActions.fetchDocuments());
			})
			.catch(function (error) {
				console.log("=== document update error ========= ");
				console.log(error);
				dispatch({
					type: documentsConstants.POST_ERROR,
					payload: error,
				});
			});
	};
}


function updateStatus(docId, status) {
	const url = `/Docs/status/${docId}`;

	return (dispatch) => {
		client
			.put(
				url,
				{},
				{
					headers: authHeader(), params: {
						statusId: Number(status),
					}
				}
			)
			.then(() => {
				dispatch(documentsActions.fetchDocuments());
			})
			.catch(function (error) {
				console.log("=== document update error ========= ");
				console.log(error);
				dispatch({
					type: documentsConstants.POST_ERROR,
					payload: error,
				});
			});
	};
}

function updateAppointedWorkers({ workerIds, docId }) {
	const url = "/docs/appointed_worker";

	const params = new URLSearchParams();
  workerIds.forEach(id => params.append('WorkerIds', id));
  params.append('DocId', docId);

	return (dispatch) => {
		client
			.put(
				`${url}?${params.toString()}`,
				{},
				{
					headers: authHeader(),
					// params: params.toString(),
				}
			)
			.then(() => {
				dispatch(documentsActions.fetchDocuments());
			})
			.catch(function (error) {
				console.log("=== document update error ========= ");
				console.log(error);
				dispatch({
					type: documentsConstants.POST_ERROR,
					payload: error,
				});
			});
	};
}

function deleteExecuter(executerId, docId) {
	const url = "/docs/delete_appointed_worker";
	return (dispatch) => {
		client
			.delete(url, {
				headers: authHeader(),
				params: {
					appointedWorkerId: Number(executerId),
					docId: Number(docId),
				}
			})
			.then(() => {
				dispatch(documentsActions.fetchDocuments());
			})
			.catch(function (error) {
				console.log("=== document update error ========= ");
				console.log(error);
				dispatch({
					type: documentsConstants.POST_ERROR,
					payload: error,
				});
			});
	};
}

function updateResponsibleWorker(
	docId,
	worker
) {
	const url = `/Docs/responsible_worker/${docId}`;
	return (dispatch) => {
		client
			.put(url, {}, {
				headers: authHeader(), params: {respWorkerId: worker.id}
			})
			.then(() => {
				dispatch(documentsActions.fetchDocuments());
			})
			.catch(function (error) {
				console.log("=== document update error ========= ");
				console.log(error);
				dispatch({
					type: documentsConstants.POST_ERROR,
					payload: error,
				});
			});
	};
}

function updateVisibility(docId, visibilityId) {
  const url = `/Docs/visibility/${docId}`;

  return (dispatch) => {
    client
      .put(url, null, {
        headers: authHeader(),
        params: {
          visibility: Number(visibilityId),
        },
      })
      .then(() => {
        dispatch(documentsActions.fetchDocuments());
      })
      .catch(function (error) {
        dispatch({
          type: documentsConstants.POST_ERROR,
          payload: error,
          // payload: 'Ошибка при изменении видимости документа',
        });
      });
  };
}

function updateNotification(docId, reminderOptionIds) {
  const url = `/Docs/doc_notification_type`;

  return (dispatch) => {
    client
      .post(
        url,
        {
          id: docId,
          notificationTypeIds: reminderOptionIds,
        },
        {
          headers: authHeader(),
        }
      )
      .then(() => {
        dispatch(documentsActions.fetchDocuments());
      })
      .catch((error) => {
        dispatch({
          type: documentsConstants.POST_ERROR,
          // payload: error,
          payload: 'Ошибка при изменении настроек оповещений документа',
        });
      });
  };
}

function updateDocNumber(docId, newValue) {
  const url = `/Docs/doc_number/${docId}`;

  return (dispatch) => {
    client
      .put(url, null, {
        headers: authHeader(),
        params: {
          docNumber: newValue,
        },
      })
      .then(() => {
        dispatch(documentsActions.fetchDocuments());
      })
      .catch((error) => {
        dispatch({
          type: documentsConstants.POST_ERROR,
          // payload: error,
          payload: 'Ошибка при изменении номера документа',
        });
      });
  };
}

function updateDocRegDate(docId, newValue) {
  const url = `/Docs/registration_date/${docId}`;

  return (dispatch) => {
    client
      .put(url, null, {
        headers: authHeader(),
        params: {
          registrationDate: fromDateStr(moment(newValue)),
        },
      })
      .then(() => {
        dispatch(documentsActions.fetchDocuments());
      })
      .catch((error) => {
        dispatch({
          type: documentsConstants.POST_ERROR,
          // payload: error,
          payload: 'Ошибка при изменении даты регистрации документа',
        });
      });
  };
}

function updateDocTopic(docId, newValue, docType = null) {
  const url = `/Docs/topic/${docId}`;
  const errTextPart = 'темы документа';
  return (dispatch) => {
    client
      .put(url, null, {
        headers: authHeader(),
        params: {
          topic: newValue,
        },
      })
      .then(() => {
        dispatch(documentsActions.fetchDocuments());
      })
      .catch((error) => {
        dispatch({
          type: documentsConstants.POST_ERROR,
          // payload: error,
          payload: `Ошибка при изменении ${errTextPart}`,
        });
      });
  };
}

/*
Метод /Docs/{id} помечен как устаревший и более не используется в проекте.
Код оставлен закомментированным для наглядности маппинга полей.
function updateDocument(value) {
	const rurl = "/docs/" + value.id;



	const data = {
		TypeId: parseInt(value.typeId),
		Topic: value.Topic,
		DocNumber: value.DocNumber,
		DocDate: value.DocMoment && value.DocMoment.format("YYYY-MM-DD"),
		InNumber: value.InNumber,
		InDate: value.InDate,
		OrgId: value.OrgId && parseInt(value.OrgId),
		AppointedWorkerId: value.executerId && parseInt(value.executerId),
		OrganizationalTypeId: value.ordTypeId && parseInt(value.ordTypeId),
		AddressId: value.addressId,
		StatusId: value.status.id
	};

	console.log(data);

	return (dispatch) => {
		client
			.put(rurl, data, { headers: authHeader() })
			.then(function (response) {
				const nr = response.data;
				console.log(nr);
				//dispatch({
				//type: actionConst.POST_DOCUMENT,
				//payload: nr
				//	})

				dispatch(documentsActions.fetchDocuments());
			})
			.catch(function (error) {
				console.log("=== document update error ========= ");
				console.log(error);
				dispatch({
					type: documentsConstants.POST_ERROR,
					payload: error,
				});
			});
	};
}
*/

function openModal(v) {
	return (dispatch) => {
		dispatch({
			type: actionConst.OPEN_MODAL,
			payload: v,
		});
	};
}

function closeModal() {
	return (dispatch) => {
		dispatch({
			type: actionConst.CLOSE_MODAL,
		});
	};
}

export default actions;
